var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sui-container',{staticClass:"password-reset-form",attrs:{"fluid":""}},[_c('Header'),_c('PasswordResetForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }